import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './PhysioManufacturerChennai.css';

const PhysioManufacturerChennai = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "logo": "https://www.primerehabindustries.in/logo.png",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "areaServed": "Tamil Nadu, India",
          "priceRange": "Contact for pricing"
        },
        {
          "@type": "Product",
          "name": "Physiotherapy and Rehabilitation Equipment",
          "description": "Prime Rehab Industries manufactures a complete range of physiotherapy and rehabilitation equipment in Chennai, including treatment tables, traction tables, tilt tables, Bobath tables, chiropractic drop tables, and unweighing systems for clinics and hospitals across India.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "125",
            "bestRating": "5"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Meena Subramaniam" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-03-15",
              "reviewBody": "We have purchased six treatment tables and a traction unit from Prime Rehab over two years. Every piece has held up well in daily clinical use with no failures. The after-sales support is also prompt and responsive."
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Rajesh Arumugam" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-06-20",
              "reviewBody": "Prime Rehab's unweighing system changed how we approach post-stroke gait rehabilitation. The build quality is solid and patients feel safe using it. We have since ordered a full paediatric therapy setup from them as well."
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Is Prime Rehab Industries a manufacturer or a dealer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries is a direct manufacturer of physiotherapy and rehabilitation equipment, based in Chennai, Tamil Nadu. We design, fabricate, and supply our own product range to clinics, hospitals, and therapy centres across India — not a dealer or distributor."
              }
            },
            {
              "@type": "Question",
              "name": "What types of physiotherapy equipment does Prime Rehab manufacture?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab manufactures over 100 equipment models covering physiotherapy, chiropractic, orthopaedic, and neurological rehabilitation. The range includes high-low treatment tables, traction tables, tilt tables, Bobath tables, chiropractic drop tables, unweighing systems, and paediatric therapy equipment."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab supply equipment outside Tamil Nadu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. While Prime Rehab Industries is headquartered in Chennai, we supply physiotherapy and rehabilitation equipment to clinics, hospitals, and therapy centres across India. We have completed more than 1,000 installations serving 500+ facilities nationwide."
              }
            },
            {
              "@type": "Question",
              "name": "Can I get custom-sized rehabilitation equipment from Prime Rehab?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries offers custom equipment sizes and configurations to suit the specific space and clinical requirements of each facility. Contact our team at +91 99943 51947 or primerehaboffl@gmail.com to discuss your requirements."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Physiotherapy & Rehabilitation Equipment Manufacturer in Chennai",
              "item": "https://www.primerehabindustries.in/blog/physiotherapy-rehabilitation-equipment-manufacturer-chennai"
            }
          ]
        }
      ]
    };

    document.title = "Physiotherapy Equipment Manufacturer Chennai | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab Industries manufactures physiotherapy and rehab equipment in Chennai. Trusted by 500+ clinics, 1,000+ installations, 12+ years of expertise.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/physiotherapy-rehabilitation-equipment-manufacturer-chennai";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {
      // Clean up if necessary
    };
  }, []);

  return (
    <div className="ind-layout-page">
      <div className="ind-grid-bg"></div>
      <Navbar />

      {/* Hero Section */}
      <section className="ind-hero">
        <div className="ind-container">
          <div className="ind-hero-inner">
            <div className="ind-hero-content">
              <span className="ind-hero-tag">Rehabilitation Equipment Guide</span>
              <h1>Physiotherapy & Rehabilitation Equipment Manufacturer in Chennai</h1>
              <p>
                Direct from factory solutions for clinics and hospitals. 100+ models, precision engineering, and a decade of manufacturing excellence.
              </p>
              <div className="ind-btn-row">
                <a href="/contact" className="ind-btn ind-btn-primary">Request Quote</a>
                <a href="/products" className="ind-btn ind-btn-outline">Browse Range</a>
              </div>
            </div>
            <div className="ind-hero-image">
              <img src="https://primerehabindustries.in/Image/Product/Pro4.png" alt="Physiotherapy and rehabilitation equipment manufacturer in Chennai Prime Rehab Industries" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="ind-section">
        <div className="ind-container">
          <div className="ind-stats-grid">
            <div className="ind-stat-card">
              <span className="ind-stat-num">12+</span>
              <span className="ind-stat-label">Years Expertise</span>
              <p>Understanding what fails in clinical settings and engineering for durability.</p>
            </div>
            <div className="ind-stat-card">
              <span className="ind-stat-num">100+</span>
              <span className="ind-stat-label">Product Models</span>
              <p>Covering every therapy specialty from physiotherapy to neuro-rehab.</p>
            </div>
            <div className="ind-stat-card">
              <span className="ind-stat-num">500+</span>
              <span className="ind-stat-label">Clinics Served</span>
              <p>Trusted by healthcare facilities across India with 1,000+ installations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section 1: Why sourcing from Manufacturer */}
      <section className="ind-section ind-section-dark">
        <div className="ind-container">
          <div className="ind-section-header">
            <div className="ind-accent-line"></div>
            <h2>Why Sourcing from a Manufacturer Makes a Difference</h2>
          </div>
          <div className="ind-tech-list">
            <div className="ind-tech-item">
              <div className="ind-tech-icon">01</div>
              <div>
                <h4>No Middlemen, No Markup</h4>
                <p>When you purchase through a dealer, you're paying for their margin. Sourcing directly from Prime Rehab means factory pricing and a single point of accountability.</p>
              </div>
            </div>
            <div className="ind-tech-item">
              <div className="ind-tech-icon">02</div>
              <div>
                <h4>Custom Configurations</h4>
                <p>Need a wider Bobath table or a lower paediatric ward bed? As manufacturers, we accommodate custom requests without re-engineering from scratch.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 1 */}
      <section className="ind-section">
        <div className="ind-container">
          <div className="ind-quote-box">
            <p className="ind-quote-text">
              "We have purchased six treatment tables and a traction unit from Prime Rehab over the past two years. Every piece has held up well in daily clinical use with no failures. The after-sales support is also prompt — they respond quickly whenever we have a question or a service need."
            </p>
            <cite className="ind-quote-author">— Dr. Meena Subramaniam, Chennai Orthopaedic & Rehab Centre</cite>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="ind-section ind-section-dark">
        <div className="ind-container">
          <div className="ind-section-header">
            <div className="ind-accent-line"></div>
            <h2>Our Equipment Range</h2>
            <p>Engineered for clinical precision and patient comfort.</p>
          </div>
          <div className="ind-prod-grid">
            <div className="ind-prod-card">
              <h4>Treatment Tables</h4>
              <p>Motorised high-low tables (48-110cm) with remote or foot pedal control. Includes 2-fold, 3-fold, and Bobath configurations.</p>
            </div>
            <div className="ind-prod-card">
              <h4>Traction & Tilt Tables</h4>
              <p>Specialised DTS tables for spinal decompression and motorized tilt tables with safety harnesses for passive weight-bearing.</p>
            </div>
            <div className="ind-prod-card">
              <h4>Unweighing Systems</h4>
              <p>Motorised bodyweight support for gait training, supporting early mobilisation in neuro and ortho rehab.</p>
            </div>
            <div className="ind-prod-card">
              <h4>Chiropractic Tables</h4>
              <p>Precision drop mechanism tables with adjustable tension for effective spinal adjustments.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 2 */}
      <section className="ind-section">
        <div className="ind-container">
          <div className="ind-quote-box">
            <p className="ind-quote-text">
              "Prime Rehab's unweighing system has genuinely changed how we approach post-stroke gait rehabilitation. The build quality is solid, patients feel safe using it, and the height adjustment is smooth under load."
            </p>
            <cite className="ind-quote-author">— Rajesh Arumugam, Vinayak Neuro Rehabilitation Centre</cite>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="ind-section ind-section-dark">
        <div className="ind-container">
          <div className="ind-section-header">
            <div className="ind-accent-line"></div>
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="ind-faq-grid">
            <div className="ind-faq-item">
              <h5>Is Prime Rehab Industries a manufacturer or a dealer?</h5>
              <p>Prime Rehab Industries is a direct manufacturer based in Chennai. We design, fabricate, and supply our own range directly to clinics, eliminating middlemen.</p>
            </div>
            <div className="ind-faq-item">
              <h5>What types of equipment do you manufacture?</h5>
              <p>Over 100 models covering physiotherapy, chiropractic, orthopaedic, and neurological rehab, including hi-low tables, traction, tilt, and unweighing systems.</p>
            </div>
            <div className="ind-faq-item">
              <h5>Do you supply equipment outside Tamil Nadu?</h5>
              <p>Yes, we supply and install equipment across India. We have completed over 1,000 installations nationwide.</p>
            </div>
            <div className="ind-faq-item">
              <h5>Can I get custom-sized equipment?</h5>
              <p>Yes. As a manufacturer, we can offer custom dimensions and configurations to suit your specific clinic space and clinical needs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="ind-section">
        <div className="ind-container">
          <div className="ind-cta-box">
            <h2>Get a Direct Quote from the Manufacturer</h2>
            <p>Find the right configuration for your clinic at a direct-from-factory price.</p>
            <div className="ind-btn-row">
              <a href="tel:+919994351947" className="ind-btn ind-btn-primary">Call: +91 99943 51947</a>
              <a href="/contact" className="ind-btn ind-btn-outline">Send Enquiry</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PhysioManufacturerChennai;
